import { app } from './app'

import '../assets/index.css'

app.$mount('#app')



// WEBPACK FOOTER //
// ./client/index.js